export default __webpack_public_path__ + "static/media/onboarding_bg.d1cbfca4.jpg";